import React, { useLayoutEffect, useRef } from "react";
import TextField from "@mui/material/TextField";
import CircleIcon from "@mui/icons-material/Circle";
import { useTranslation } from "react-i18next";
import { colors } from "../../../framework/theme";
import {
    TransportOrderListItemDto,
    TransportOrderState,
    transportOrderStateNames,
    transportOrderStates,
} from "../../../models/transport/transportOrder";
import {
    GridRenderEditCellParams,
    useGridApiContext,
} from "@mui/x-data-grid-premium";
import MuiMenu from "../../framework/muiMenu";

export const OrderStateSelect = ({
    id,
    field,
    value,
    hasFocus,
}: GridRenderEditCellParams<TransportOrderListItemDto>) => {
    const apiRef = useGridApiContext();
    const { t } = useTranslation();

    const handleValueChange = async(value: TransportOrderState) =>
        await apiRef.current.setEditCellValue({ id, field, value });

    const items = [
        {
            label: t(
                transportOrderStateNames[TransportOrderState.OrderCreated]
            ),
            icon: (
                <CircleIcon fontSize="small" htmlColor={colors.orange.main} />
            ),
            onClick: () =>
                void handleValueChange(TransportOrderState.OrderCreated),
        },
        {
            label: t(transportOrderStateNames[TransportOrderState.PickedUp]),
            icon: <CircleIcon fontSize="small" htmlColor={colors.blue.main} />,
            onClick: () => void handleValueChange(TransportOrderState.PickedUp),
        },
        {
            label: t(transportOrderStateNames[TransportOrderState.Delivered]),
            icon: <CircleIcon fontSize="small" htmlColor={colors.green.main} />,
            onClick: () =>
                void handleValueChange(TransportOrderState.Delivered),
        },
        {
            label: t(transportOrderStateNames[TransportOrderState.Cancelled]),
            icon: <CircleIcon fontSize="small" htmlColor={colors.yellow.main} />,
            onClick: () =>
                void handleValueChange(TransportOrderState.Cancelled),
        },
    ];

    const selectedColor = transportOrderStates.find(
        (s) => s.value === value
    )?.color;

    return (
        <MuiMenu
            label={<CircleIcon fontSize="small" htmlColor={selectedColor} />}
            size="small"
            items={items}
            sx={{ marginLeft: "4px" }}
            defaultOpen={hasFocus}
        />
    );
};

export const OrderIdentifier = ({
    id,
    field,
    value,
    hasFocus,
}: GridRenderEditCellParams<TransportOrderListItemDto>) => {
    const apiRef = useGridApiContext();
    const ref = useRef<HTMLInputElement>();

    useLayoutEffect(() => {
        if (hasFocus) {
            ref.current?.focus();
        }
    }, [hasFocus]);

    const handleValueChange = async(
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const newValue = event.target.value; // The new value entered by the user
        await apiRef.current.setEditCellValue({ id, field, value: newValue });
    };

    return (
        <TextField
            size="small"
            ref={ref}
            fullWidth
            value={value ?? ""}
            className="mui-custom-input"
            name="name"
            onChange={(e) => void handleValueChange(e)}
        />
    );
};
